import { LineSvgProps } from '@nivo/line';

export const LINE_COLOR = '#6BA0FF';
export const COMMON_RESPONSIVE_LINE_PROPS: Partial<LineSvgProps> = {
  lineWidth: 2,
  colors: [LINE_COLOR],
  margin: { top: 20, right: 70, bottom: 30, left: 5 },
  xScale: {
    type: 'time',
    precision: 'day',
    format: '%Y-%m-%d',
    useUTC: false,
  },
  axisBottom: {
    format: '%b %y',
    tickSize: 0,
  },
  axisRight: {
    tickSize: 0,
    tickPadding: 10,
    tickValues: 6,
  },
  axisLeft: {
    tickSize: 0,
    // hide the left labels. Couldn't find a better way to do this
    format: () => '',
  },
  enablePoints: false,
  enableSlices: 'x',
  enableGridX: false,
  theme: {
    text: {
      fontFamily: 'Avenir, sans-serif',
      fill: '#4A4A4A',
      fontSize: 12,
    },
    crosshair: {
      line: {
        stroke: '#C4C4C4',
        strokeDasharray: '1',
      },
    },
    grid: {
      line: {
        stroke: '#F7F7F7',
      },
    },
  },
};
